import React from 'react';

const LiveBroadcastIcon: React.FC = () => (
    <svg width="44" height="34" viewBox="0 0 44 34" fill="none" stroke="#d4380d" strokeWidth="2.6" strokeLinecap="round" role="img" aria-label="Live clock">
        <title>Live clock</title>
        <circle cx="22" cy="17" r="4.5" fill="#d4380d" stroke="none" />
        <path d="M14 9a11 11 0 0 0 0 16M30 9a11 11 0 0 1 0 16" />
        <path d="M8 4a18 18 0 0 0 0 26M36 4a18 18 0 0 1 0 26" />
    </svg>
);

export default LiveBroadcastIcon;
